<template>
  <form autocomplete="off">
    <!-- 表单 -->
    <van-cell-group :border="false">
      <base-field
        v-for="(item, index) in items"
        ref="items"
        :key="item.name"
        :name="item.name"
        :init-value.sync="item.value"
        :readonly="item.readonly"
        :disabled="item.disabled"
        :label-width="labelWidth"
        :showKeyboard="item.showKeyboard"
        :error="errorState[item.name]"
        @clear="onClear(item.name)"
        @map="onMap($event, item.name, index, item)"
        @iconEvent="handlerIconEvent(item, index)"
        @focus="onFocus"
      >
        {{ mapValues }} {{ mapValues.iconPhone }}
        <the-send-code
          v-if="handlerSend(item.name)"
          ref="send"
          slot="button"
          :hasSendCaptcha="hasCaptcha === 'send'"
          :phone="item.phone || phone"
          :loginCode="item.loginCode"
          :moduleType="item.moduleType"
          :type="item.type"
        />
      </base-field>
    </van-cell-group>
    <!-- 复选框 -->
    <the-checkboxGroup
      v-if="checkInfo"
      :checkInfo="checkInfo"
      @getCheckResult="getCheckResult"
    />
    <!-- 上传 -->
    <the-uploader
      v-if="uploader.isUploader"
      ref="uploader"
      :uploader="uploader"
      @update="setUploadImg"
    />
    <!-- 按钮 -->
    <div v-if="!locked" :class="$style.submit">
      <van-button
        round
        type="primary"
        size="large"
        tag="input"
        native-type="submit"
        :value="submitText"
        :disabled="disabled"
        @click.stop.prevent="submitHandler"
      />
    </div>
    <!-- 上拉菜单 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :columns="actions"
        show-toolbar
        title="请选择选项"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </form>
</template>

<script>
import { Toast } from "vant";
import jzValidator from "@jz/validator";

import BaseField from "@/components/BaseField";
import TheSendCode from "@/components/TheSendCode";
import TheUploader from "@/components/TheUploader";
import TheCheckboxGroup from "@/components/TheCheckboxGroup";
let timer = null;

export default {
  name: "BaseForm",
  components: {
    BaseField,
    TheSendCode,
    TheUploader,
    TheCheckboxGroup
  },
  provide() {
    return {
      $validator: this.$validator
    };
  },
  props: {
    currentIndex: Number,
    checkInfo: Object,
    items: Array,
    labelWidth: { type: String, default: "2em" },
    hasCaptcha: { type: [Boolean, String], default: false }, // 是否启用极验验证, 当值为 true 时, 在提交表单时验证, 当值为 'send' 时, 在获取手机验证码时验证, 非以上状态是, 设置值为 'other'
    submitText: { type: String, default: "提 交" },
    locked: { type: Boolean, default: false },
    actions: Array,
    uploader: {
      type: Object,
      default: () => {
        return {
          isUploader: false,
          reqiure: false
        };
      }
    }
  },
  data() {
    return {
      checkResult: [], //复选框
      uploadImg: [], //图标
      disabled: false, // 提交按钮禁用状态
      validator: null, // 极致验证
      errorState: {}, //错误
      mapValues: {}, //表单值
      showPicker: false, //picker显示
      pickerIndex: "", //picker显示索引
      formData: undefined
    };
  },
  computed: {
    phone() {
      if (this.mapValues) {
        return (
          this.mapValues.iconPhone ||
          this.mapValues.telphone ||
          this.mapValues.bindPhone
        );
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.initialCaptcha();
    // 初使化error
    this.items.map(el => {
      this.$set(this.errorState, el.name, false);
    });
  },
  destroyed() {
    if (this.validator && this.validator.type !== "aliyun2.0") {
      this.validator.reset();
    }
  },
  watch: {
    hasCaptcha(val) {
      if (val && !this.validator) {
        this.initialCaptcha();
      }
    }
  },
  methods: {
    /**
     * @description 初始化极致验证
     */
    initialCaptcha() {
      if (this.hasCaptcha && this.hasCaptcha !== "send") {
        jzValidator(
          captchaObj => {
            // 验证成功回调
            captchaObj.success(() => {
              if (
                this.hasCaptcha &&
                this.hasCaptcha !== "send" &&
                this.validator.type !== "aliyun2.0"
              ) {
                // 表单提交
                this.submitHandler();
              }
            });

            // 关闭验证回调
            captchaObj.close(() => {
              //表单提交
              if (this.hasCaptcha) {
                this.disabled = false;
                if (this.hasCaptcha === "send") {
                  this.$refs.send[0].countdown = 0;
                }
              }
            });

            this.validator = captchaObj;
          },
          {
            scene:
              this.hasCaptcha === "send"
                ? "sms"
                : this.hasCaptcha === "other"
                ? "other"
                : "log",
            captchaVerifyCallback: async captchaVerifyParam => {
              const result = await new Promise(resolve => {
                this.$emit(
                  "submit",
                  this.formData,
                  { captchaVerifyParam },
                  resolve
                );
              });
              return {
                captchaResult: result !== 2100 ? true : false,
                bizResult: result === 0
              };
            }
          }
        );
      }
    },
    /**
     * @description 验证图片是否上传
     */
    validateImg() {
      if (this.uploader.reqiure && this.uploadImg.length == 0) {
        this.$Toast("请上传图片");
        this.disabled = false;
        return false;
      }
      return true;
    },
    /**
     * @description 验证复选框是否选择
     */
    validateCheckbox() {
      if (
        this.checkInfo &&
        this.checkInfo.reqiure &&
        this.$parent.resetId.length == 0
      ) {
        this.$Toast(`请选择${this.checkInfo.title}`);
        this.disabled = false;
        return false;
      }
      return true;
    },
    /**
     * @description 表单提交
     */
    submitHandler() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timer = setTimeout(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            // 表单项验证成功
            this.disabled = true;
            // 获取表单项的值
            this.formData = {};
            for (let elem of this.$refs.items.values()) {
              this.formData[elem.name] = elem.value;
            }
            //验证是否有图片
            if (this.validateImg() == false) return;
            //验证是否有选择框
            if (this.validateCheckbox() == false) return;
            // 是否进行安全验证
            if (this.hasCaptcha && this.hasCaptcha !== "send") {
              if (this.validator) {
                if (this.validator.type === "aliyun2.0") {
                  this.validator.verify();
                } else {
                  let validate = this.validator.getValidate();
                  validate
                    ? this.$emit("submit", this.formData, validate)
                    : this.validator.verify();
                }
              } else {
                Toast("网络异常，刷新后重试");
              }
            } else {
              this.$emit("submit", this.formData);
            }
          } else {
            this.validError();
          }
        });
        clearTimeout(timer);
        timer = null;
      }, 300);
    },
    /**
     * @description 提交表单错误显示
     */
    validError() {
      let errors = this.errors.collect();
      for (let i in errors) {
        this.$set(this.errorState, i, true);
        this.$Toast(errors[i][0]);
        break;
      }
    },
    /**
     * @description 清空表单内容
     * @param {string} name  - 表单项名称
     */
    onClear(name) {
      this.$set(this.errorState, name, false);
    },
    /**
     * @description 点击input聚焦事件
     * @param {string} value  - 表单项值
     * @param {string} name  -  表单项名称
     */
    onFocus(isFoucs, name) {
      this.$route.name == "ask" && this.$parent.setProblemTep(isFoucs, name);
    },
    /**
     * @description 获取复选框值
     * @param {array} val  - 复选框值
     */
    getCheckResult(val) {
      this.$parent.resetId = val;
    },
    /**
     * @description 设置表单的值
     * @param {string} value  - 表单项值
     * @param {string} name  -  表单项名称
     */
    onMap(value, name, index) {
      this.currentIndex
        ? this.$emit("giveData", this.currentIndex, name, value)
        : this.$emit("getData", index, value);

      this.$set(this.mapValues, name, value);
      this.hiddenTip();
    },
    /**
     * @description 隐藏申诉工单提示
     */
    hiddenTip() {
      this.$route.name == "appealFind" &&
        this.$parent.tipShow == true &&
        this.$emit("showTip");
    },
    /**
     * @description 图标显示
     * @param {object} item  - 表单对象值
     * @param {number} index - 索引
     */
    handlerIconEvent(item, index) {
      if (!item.iconType) return;
      let eventList = {
        //pick选择
        1: () => {
          this.$set(this.errorState, item.name, false);
          this.showPicker = !this.showPicker;
          this.pickerIndex = index;
          this.$emit("actionShow", index);
        },
        2: () => {
          this.$emit("showTip");
        },
        3: () => {
          this.$Toast("请先选择服务器");
        },
        4: () => {
          this.$Toast("未查询到角色，请重新选择服务器");
        }
      };
      eventList[item.iconType]();
    },
    /**
     * @description 设置图片地址
     * @param {string} val  - 图片地址
     */
    setUploadImg(val) {
      this.uploadImg = val;
    },
    /**
     * @description 清空图片地址
     */
    clearImg() {
      this.$refs.uploader.clearImg();
    },
    /**
     * @description picker确认选择选项
     * @param {object}} val  - 选择值
     */
    onConfirm(val) {
      this.showPicker = false;
      this.$emit("setActionValue", this.pickerIndex, val);
    },
    /**
     * @description 发送验证码显示
     * @param {string} name  - 表单项名称
     */
    handlerSend(name) {
      let nameList = ["iconPhoneCode", "telCode"];
      return nameList.includes(name);
    },
    /**
     * @description 控制验证码倒计时
     */
    handlerSendNum() {
      this.$refs.send[0].clearNum();
    }
  }
};
</script>

<style lang="less" module>
.submit {
  margin-top: 0.6rem;
  text-align: center;
}
</style>
